import { APPS, DEVICES, DEVICES_LOCATIONS, NEED_HELP, WHY } from '@/constants/notes-descriptions'
import { QID_APP_USERS, QID_DEVICES } from '@/constants/question-ids'
import ifArrIncludes from '@/helpers/ifArrIncludes'
import ObjectToString from '@/helpers/ObjectToString'

const NotesEncoder = {
  encode (state, rootState) {
    let notes = `${this.addressString(rootState)}\n`
    notes += this.profileString(state)
    return notes
  },

  addressString (state) {
    const address = state.AddressLookup.address
    const addressFields = ['id', 'buildingNumber', 'buildingName', 'subBuilding', 'street', 'secondaryStreet', 'district', 'city', 'province', 'postcode']

    return `(Address:${addressFields.map(field => address[field]).join(',')})`
  },

  profileString (state) {
    const optionsMap = {
      'inclusive-calls': 'Inclusive',
      'remote-working': 'Remote',
      'virtual-receptionist': 'VirtualRep',
      'smart-call-routing': 'SmartRout',
      'mobile-app': 'MobileApp',
      'scalability': 'Scale',
      'call-recording-call-logging': 'CallLog',
      'other-no-preference': 'Other',
      handsets: 'Handsets',
      pc: 'PC',
      other: 'Other'
    }

    const questionsMap = {
      'qid_voip_features': 'FeaturePref',
      'qid_voip_kit': 'NewSystemPref'
    }

    let profile = []

    if (state.answers.qid_voip_user) profile.push(`Voip:${state.answers.qid_voip_user.result}`)
    if (state.answers.qid_current_supplier) profile.push(`BBSupplier:${state.answers.qid_current_supplier.result.value}`)
    profile.push(this.answersMap(state, [Object.keys(questionsMap)[0]], optionsMap, questionsMap))
    if (state.answers.qid_how_many_users) profile.push(`Users:${state.answers.qid_how_many_users.result.value}`)
    // WHY
    if (state.answers.qid_why_comparing) profile.push(`${WHY}:${state.answers.qid_why_comparing.result}`)
    // DEVICE LOCATIONS
    if (state.answers.qid_locations) profile.push(`${DEVICES_LOCATIONS}: ${state.answers.qid_locations.result}`)
    // DEVICES
    if (state.answers[QID_DEVICES]) {
      if (ifArrIncludes(state.skippedQuestions, QID_DEVICES)) {
        profile.push(`${DEVICES}: ${NEED_HELP}`)
      } else {
        profile.push(`${DEVICES}: ${ObjectToString(state.answers[QID_DEVICES].result)}`)
      }
    }
    // APPS
    if (state.answers[QID_APP_USERS]) {
      if (ifArrIncludes(state.skippedQuestions, QID_APP_USERS)) {
        profile.push(`${APPS}: ${NEED_HELP}`)
      } else {
        profile.push(`${APPS}: ${state.answers[QID_APP_USERS].result}`)
      }
    }
    profile.push(this.answersMap(state, [Object.keys(questionsMap)[1]], optionsMap, questionsMap))

    return profile.join('\n')
  },

  answersMap (state, qids, map, qidMap) {
    let results = []

    qids.forEach(qid => {
      if (state.answers[qid]) {
        results.push(`${qidMap[qid]}:${state.answers[qid].result.map(result => map[result.value]).filter(Boolean)}`)
      }
    })

    return results
  }
}

export default NotesEncoder
